const fixedService = () => {
  return {
    name: 'Schedule R14',
    title: 'Residential Service (Experimental)',
    rateElements: [
      // Fixed Monthly Charge
      {
        rateElementType: 'FixedPerMonth',
        name: 'Basic Customer Charge',
        rateComponents: [
          {
            charge: 25.5,
            name: 'Basic Customer Charge',
          },
        ],
      },
      // Energy Charges for Distribution kWh
      {
        rateElementType: 'EnergyTimeOfUse',
        name: 'Distribution kWh Charge - Winter',
        classificaition: 'energy',
        billingCategory: 'delivery',
        rateComponents: [
          {
            charge: 0.1295, // 12.9500¢ per kWh
            months: [1, 2, 3, 4, 5, 10, 11, 12], // January - May and October - December
            daysOfWeek: [0, 1, 2, 3, 4, 5, 6], // All Days
            hourStart: [
              0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18,
              19, 20, 21, 22, 23,
            ], // All
            name: 'Winter On-Peak kWh Charge',
          },
        ],
      },

      {
        rateElementType: 'EnergyTimeOfUse',
        name: 'Distribution kWh Charge - Summer',
        classification: 'energy',
        billingCategory: 'delivery',
        rateComponents: [
          {
            charge: 0.2069, // 20.6900¢ per kWh
            months: [6, 7, 8, 9], // June - September
            daysOfWeek: [0, 1, 2, 3, 4, 5, 6], // All Days
            hourStart: [
              0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18,
              19, 20, 21, 22, 23,
            ], // All
            name: 'Summer On-Peak kWh Charge',
          },
        ],
      },
    ],
  };
};

export default fixedService;
